import { render, staticRenderFns } from "./TitleText.vue?vue&type=template&id=04b14eea&"
import script from "./TitleText.vue?vue&type=script&lang=js&"
export * from "./TitleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_babel-core@7.0.0-bridge.0_@babel+core@7.12.10__css-loader@5.0.1_webpa_2f9c74bd8b0234781e6cf928f27b0315/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b14eea')) {
      api.createRecord('04b14eea', component.options)
    } else {
      api.reload('04b14eea', component.options)
    }
    module.hot.accept("./TitleText.vue?vue&type=template&id=04b14eea&", function () {
      api.rerender('04b14eea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/TitleText.vue"
export default component.exports